// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"vn-z","categoryName":"wn-z","categoryImage":"xn-z","categoryContent":"yn-z","bottomAligned":"zn-z"};